<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
var INVITE_STORAGE_KEY = 'mall_invite_state';

function normalizeInviteValue(value) {
    if (Array.isArray(value)) {
        value = value[0];
    }
    if (value === undefined || value === null) {
        return '';
    }
    return String(value).trim();
}

function readInviteState() {
    try {
        var raw = window.localStorage.getItem(INVITE_STORAGE_KEY);
        var state = raw ? JSON.parse(raw) : {};
        return state && typeof state === 'object' ? state : {};
    } catch (e) {
        return {};
    }
}

function writeInviteState(query) {
    var ivuid = normalizeInviteValue(query && query.ivuid);
    var ivkey = normalizeInviteValue(query && query.ivkey);
    var state = readInviteState();
    var changed = false;

    if (!ivuid && !ivkey) {
        window.mallInviteStateValue = state;
        return state;
    }

    if (ivuid && !state.ivuid) {
        state.ivuid = ivuid;
        changed = true;
    }
    if (ivkey && !state.ivkey) {
        state.ivkey = ivkey;
        changed = true;
    }

    if (changed) {
        try {
            window.localStorage.setItem(INVITE_STORAGE_KEY, JSON.stringify(state));
        } catch (e) {}
    }

    window.mallInviteStateValue = state;
    return state;
}

function getInviteParams(query) {
    var state = readInviteState();
    return {
        ivuid: state.ivuid || normalizeInviteValue(query && query.ivuid) || '',
        ivkey: state.ivkey || normalizeInviteValue(query && query.ivkey) || '',
    };
}

if (typeof window !== 'undefined') {
    window.mallInviteState = {
        key: INVITE_STORAGE_KEY,
        sync: writeInviteState,
        get: getInviteParams,
    };
}

export default {
    name: 'App',
    data() {
        return {
            isRouterAlive: true
        }
    },
    watch: {
        '$route.fullPath'() {
            this.syncInviteState()
        }
    },
    methods: {
        syncInviteState() {
            if (typeof window === 'undefined' || !window.mallInviteState) {
                return
            }
            window.mallInviteState.sync(this.$route && this.$route.query ? this.$route.query : {})
        }
    },
    created() {
        // console.log('sessionStorage', typeof sessionStorage, sessionStorage);
        this.syncInviteState()
        this.$toast.allowMultiple()

        var ip = this.$tool.data.get('clientip');
        // console.log('ip', ip);
        if (!ip) {
            this.$api.post('index/ajax/getClientIp', {}, {
                ws: false
            }).then((res) => {
                if (res.code == 200) {
                    this.$tool.data.set('clientip', res.data.ip);
                } else {
                    this.$toast.fail('服务器请错误，请联系网站管理员处理=>' + res.message)
                }
            }).catch((err) => {
                console.log(err);
            });

        }

        var loading = this.$tool.cookie.get('config.loading');
        if (!loading) {
            this.$api.post('index/store/h5/index/getConfig')
                .then((res) => {
                    if (res.code == 200) {
                        this.$tool.cookie.set('config.loading', true, 86400);
                        this.$tool.data.set('config', res.data);
                    } else {
                        this.$toast.fail('页面配置加载失败，' + res.message)
                    }
                }).catch((err) => {
                    console.log(err);
                });

        }


    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue